module.exports = __webpack_public_path__ + "img/emoji_deyi.fcde75cf.png";